export default "__VITE_ASSET__$BljB2IW__"